/**
 * @file rand Generate random HEX string.
 * @author yuzong(yuzong@tencent.com)
 */

/**
 * Generate random HEX string
 *
 * @param digit Length of result
 */
export function rand(digit) {
  return ((1 + Math.random()) * (1 << digit * 4) | 0).toString(16).substring(1);
}